export default "__VITE_ASSET__B0A87M9f__"